/* eslint-disable import/no-unresolved */
import { Icons } from '@/types/icons';

import arrowUp from '@/assets/icons/arrowUp';
import cancel from '@/assets/icons/cancel';
import check from '@/assets/icons/check';
import clipboard from '@/assets/icons/clipboard';
import customers from '@/assets/icons/customers';
import dashboard from '@/assets/icons/dashboard';
import disconnect from '@/assets/icons/disconnect';
import menu from '@/assets/icons/menu';
import orderList from '@/assets/icons/orderList';
import orders from '@/assets/icons/orders';
import settings from '@/assets/icons/settings';
import tables from '@/assets/icons/tables';
import logo from '@/assets/icons/logo';
import logout from '@/assets/icons/logout';
import search from '@/assets/icons/search';
import arrowLeft from '@/assets/icons/arrowLeft';
import invoice from '@/assets/icons/invoice';
import report from '@/assets/icons/report';
import calendar from '@/assets/icons/calendar';
import time from '@/assets/icons/time';

const icons: Record<Icons, string> = {
  arrowUp,
  cancel,
  check,
  clipboard,
  customers,
  dashboard,
  logout,
  menu,
  orderList,
  orders,
  settings,
  tables,
  logo,
  disconnect,
  search,
  arrowLeft,
  invoice,
  report,
  calendar,
  time,
};

export default icons;
